/*
  This is the monolithic component for the Whimsical Animations blog post. It renders one of the demos on that page, based on the `variant` prop.

  This is tricky in TypeScript, but I asked on BlueSky and got lots of suggestions here: https://bsky.app/profile/joshwcomeau.com/post/3likixzrilk27

  I can migrate to another solution if this one (from Kyle) doesn’t work out.
*/

import IconBoopDemo, {
  Props as IconBoopDemoProps,
} from './IconBoopDemo/IconBoopDemo';
import EraserExplanation from './EraserExplanation/EraserExplanation';
import BombExaggeration from './BombExaggeration/BombExaggeration';
import BombPivotDiagram from './BombPivotDiagram';
import CartesianVsPolar from './CartesianVsPolar/CartesianVsPolar';
import EraserWiggle from './EraserWiggle';
import SynthLayersDemo from './SynthLayersDemo/SynthLayersDemo';
import ShapesColorModeToggle from './ShapesColorModeToggle';
import SliderSFXDemo from './SliderSFXDemo/SliderSFXDemo';
import ButtonPushDemo from './ButtonPushDemo/ButtonPushDemo';

const MAP = {
  IconBoopDemo,
  EraserExplanation,
  BombExaggeration,
  BombPivotDiagram,
  CartesianVsPolar,
  EraserWiggle,
  SynthLayersDemo,
  ShapesColorModeToggle,
  SliderSFXDemo,
  ButtonPushDemo,
} as const;

type WhimsicalAnimationsDemoProps =
  | ({ variant: 'IconBoopDemo' } & IconBoopDemoProps)
  | { variant: 'EraserExplanation' }
  | { variant: 'BombExaggeration' }
  | { variant: 'BombPivotDiagram' }
  | { variant: 'CartesianVsPolar' }
  | { variant: 'EraserWiggle' }
  | { variant: 'SynthLayersDemo' }
  | { variant: 'ShapesColorModeToggle' }
  | { variant: 'SliderSFXDemo' }
  | { variant: 'ButtonPushDemo' };

export default function WhimsicalAnimationsDemo(
  props: WhimsicalAnimationsDemoProps
) {
  const Component = MAP[props.variant];
  return <Component {...props} />;
}
